import React, { ReactNode } from 'react';
import './button.scss';

interface Props  {
    children: ReactNode;
    onClick?: any;
    type: "button" | "submit" | "reset";
    style?: string;
    disabled?: boolean;
    testid?: string;
}

const Button: React.FC<Props> = ({
  children, type, onClick, style, disabled, testid
}) => {
  return (
    <button onClick={onClick} className= {`button ${style}`} type={type} disabled={disabled} data-testid={testid}>
      {children}
    </button>
  );
};

export default Button;
